module.exports = __webpack_public_path__ + "static/img/疫情守护.2e53d3c.gif";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/疫情守护.gif
// module id = WFZ2
// module chunks = 3